<template>
	<Layout>
		<div class="l-container">
			<VideoCenter
				:teams="teams"
				:recommended="recommended"
				:league-id="leagueId"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import VideoCenter from '@js/components/MatchCenter/VideoCenter.vue';

export default {
	name:       'ViewVideoCenterLeague',
	components: { Layout, VideoCenter },
	props:      {
		teams: {
			type:     Array,
			required: true,
		},
		recommended: {
			type:    Array,
			default: () => [],
		},
		leagueId: {
			type:     Number,
			required: true,
		},
	},
};
</script>

<style>

</style>
